var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("div", { staticClass: "title-con" }, [
        _c("div", { staticClass: "return-btn-con" }, [
          _c(
            "button",
            {
              staticClass: "return-btn",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("c-svg", {
                attrs: {
                  src: "return.svg",
                  width: "21",
                  height: "21",
                  fill: "rgb(217, 222, 229)",
                },
              }),
              _c("div", { staticClass: "text" }),
            ],
            1
          ),
        ]),
        _c("h1", { staticClass: "case-title" }, [_vm._v("免费盲盒 FreeCases")]),
        _c("div", { staticClass: "block" }),
      ]),
      _c("div", { staticClass: "free-bg-head" }),
      _c("div", { staticClass: "free-case-con" }, [
        _c("div", { staticClass: "free-bg-left-head" }),
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "inv-box",
            on: {
              click: function ($event) {
                return _vm.copy(_vm.share_link)
              },
            },
          },
          [
            _vm._v(" 分享给好友: "),
            _c("div", { staticClass: "link" }, [
              _c("i", { staticClass: "ivu-icon ivu-icon-ios-link" }),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.share_link)),
              ]),
            ]),
          ]
        ),
        _c(
          "ul",
          { staticClass: "free-case-list" },
          _vm._l(_vm.caseList, function (case_item, case_item_index) {
            return _c(
              "li",
              {
                key: case_item_index,
                on: {
                  click: function ($event) {
                    return _vm.get_case_info(case_item.caseId)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "free-case",
                    class: { acitve: _vm.case_info.caseId == case_item.caseId },
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm._f("imgfilter")(case_item.casePic) },
                    }),
                    case_item.conditionVal > _vm.totalInviteCount
                      ? _c("div", { staticClass: "btn" }, [
                          _vm._v(
                            "未达成(" +
                              _vm._s(_vm.totalInviteCount) +
                              "/" +
                              _vm._s(case_item.conditionVal) +
                              " )"
                          ),
                        ])
                      : _c("div", { staticClass: "btn acitve" }, [
                          _vm._v("立即开启"),
                        ]),
                    case_item.conditionVal > _vm.totalInviteCount
                      ? _c("div", { staticClass: "lock" })
                      : _vm._e(),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "case-ani-con" },
        [
          _c("div", { staticClass: "light" }),
          _vm.case_awards.length && _vm.case_open_number <= 1
            ? _c("p-case-opening", {
                key: _vm.case_info.caseId,
                ref: "case_opening_box",
                attrs: {
                  items: _vm.case_awards,
                  isTransition: !_vm.is_jump_case_open_animation,
                },
                on: {
                  on_finished: function () {
                    return _vm.on_case_opened()
                  },
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "ctrl-con" }, [
            _c(
              "button",
              {
                staticClass: "open-case-btn",
                on: {
                  click: function () {
                    return _vm.case_open("normal")
                  },
                },
              },
              [_vm._v(" 立即开启 OPEN ")]
            ),
            _c("div", { staticClass: "jump-animate-con" }, [
              _c(
                "div",
                { staticClass: "jump-animate" },
                [
                  _c("i-switch", {
                    attrs: {
                      "false-color": "#14131d",
                      "true-color": "#827dff",
                    },
                    on: { "on-change": _vm.toggle_is_jump_case_open_animation },
                    model: {
                      value: _vm.is_jump_case_open_animation,
                      callback: function ($$v) {
                        _vm.is_jump_case_open_animation = $$v
                      },
                      expression: "is_jump_case_open_animation",
                    },
                  }),
                  _c("span", { staticClass: "text" }, [_vm._v("动画")]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "case-award-title-con" }, [
        _c("h2", { staticClass: "case-award-title" }, [
          _vm._v("此箱子包含以下物品"),
        ]),
        _c("div", { staticClass: "probability" }, [
          _c("div", { staticClass: "title" }, [_vm._v("掉落概率")]),
          _c("div", { staticClass: "rate_list_con" }, [
            _c("ul", { staticClass: "rate_list" }, [
              _vm.case_info.groupRateG
                ? _c("li", { staticClass: "gold" }, [
                    _vm._v(
                      " " +
                        _vm._s((_vm.case_info.groupRateG / 100).toFixed(2)) +
                        "%"
                    ),
                  ])
                : _vm._e(),
              _vm.case_info.groupRateR
                ? _c("li", { staticClass: "red" }, [
                    _vm._v(
                      " " +
                        _vm._s((_vm.case_info.groupRateR / 100).toFixed(2)) +
                        "%"
                    ),
                  ])
                : _vm._e(),
              _vm.case_info.groupRateP
                ? _c("li", { staticClass: "purple" }, [
                    _vm._v(
                      " " +
                        _vm._s((_vm.case_info.groupRateP / 100).toFixed(2)) +
                        "% "
                    ),
                  ])
                : _vm._e(),
              _vm.case_info.groupRateW
                ? _c("li", [
                    _vm._v(
                      " " +
                        _vm._s((_vm.case_info.groupRateW / 100).toFixed(2)) +
                        "%"
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "ruler-text",
              on: {
                click: function ($event) {
                  _vm.notice_modal_show = true
                },
              },
            },
            [
              _c("span", [_vm._v("概率说明")]),
              _c("img", {
                attrs: {
                  src: require("../../assets/images/help_fill.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "case-award-list-con" }, [
        _c(
          "div",
          { staticClass: "case-award-list" },
          _vm._l(_vm.case_awards, function (item, award_index) {
            return _c("c-award", {
              key: award_index,
              attrs: {
                rarity:
                  item.groupId == 0
                    ? 1
                    : item.groupId == 1
                    ? 4
                    : item.groupId == 2
                    ? 6
                    : 7,
                picture: item.itempic,
                name: item.itemname,
                price: item.price,
              },
            })
          }),
          1
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            closable: false,
            width: "'400rem'",
          },
          model: {
            value: _vm.is_case_open_cdk_modal_show,
            callback: function ($$v) {
              _vm.is_case_open_cdk_modal_show = $$v
            },
            expression: "is_case_open_cdk_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: _vm.case_info.caseName, has_close_button: "" },
              on: { close_button_click: _vm.toggle_case_open_cdk_modal_show },
            },
            [
              _c("div", { staticClass: "case-open-cdk app-form" }, [
                _c("p", { staticClass: "case-open-cdk__desc" }, [
                  _vm._v("请输入您的CD-KEY，以开启箱子"),
                ]),
                _c("label", { staticClass: "app-form__field" }, [
                  _c("div", { staticClass: "app-form__field_icon_input" }, [
                    _c("i", { staticClass: "ivu-icon ivu-icon-md-key" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.case_open_cdk,
                          expression: "case_open_cdk",
                        },
                      ],
                      staticClass: "app-form__field__input pad50",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder: "请输入您的CD-KEY",
                      },
                      domProps: { value: _vm.case_open_cdk },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.case_open_cdk = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: {
                    click: function ($event) {
                      return _vm.case_open("cdk")
                    },
                  },
                },
                [_vm._v("确认开箱")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "开箱概率说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v("每次开启盲盒为新的一轮"),
                  _c("span", [_vm._v("独立计算")]),
                  _vm._v(" ，多次开启盲盒并"),
                  _c("span", [_vm._v("不意味")]),
                  _vm._v("着某区间"),
                  _c("span", [_vm._v("概率累加")]),
                  _vm._v(" 。"),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例1：")]),
                _c("p", [
                  _vm._v("盲盒内有A、B两件饰品,获得概率都为"),
                  _c("span", [_vm._v("50%")]),
                  _vm._v(",当连续开启该盲盒时, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("开启结果"),
                  _c("span", [_vm._v("稳定")]),
                  _vm._v("为ABABAB "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例2： ")]),
                _c("p", [
                  _vm._v(" 某饰品掉率为"),
                  _c("span", [_vm._v("10%")]),
                  _vm._v(", 当连续开启该盲盒时, "),
                  _c("span", [_vm._v("可能10次无掉落")]),
                  _vm._v("该饰品, 也可能20次掉落1次, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("每开10次"),
                  _c("span", [_vm._v("必定掉落")]),
                  _vm._v("1次该饰品 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", { ref: "case_reward_ui" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "free-case-title" }, [
      _vm._v("邀请好友助力 "),
      _c("span", [_vm._v("获取免费箱子!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }